import React, { Component } from 'react'
import GoogleTagManager from 'gtm'

import MenuOffCanvas from 'components/MenuOffCanvas'
import Header from 'components/Header'
import HomeContent from 'modules/HomeContent'
import Footer from 'components/Footer'

import SurveyControllerContainer from 'modules/Controllers/Survey/SurveyControllerContainer'
import HTMLTitleController from 'modules/Controllers/HTMLTitle/HTMLTitleController'

class Home extends Component {
  render() {
    return (
      <div className="App">
        <GoogleTagManager gtmId="GTM-NXH8F9G" />
        <SurveyControllerContainer />
        <MenuOffCanvas />
        <Header />
        <HomeContent />
        <Footer />
        <HTMLTitleController />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home/Home.jsx